import classNames from 'classnames';
import type { ComponentProps, ReactNode } from 'react';
import styled from 'styled-components';

import { Tab, TabBar } from 'atoms/navigation/TabBar';

const StyledTabBar = styled(TabBar)`
  --active-fg-color: var(--c-white);
  --active-bg-color: var(--c-nd-200);
`;
const StyledTab = styled(Tab)`
  width: 50%;
  &.onlyGrowOnSelected {
    flex: 0 0 auto;
    width: auto;
    .fullWidth & {
      flex: 0 0 auto;
      width: auto;
    }
  }
  &.growOnSelected {
    flex-grow: 1;
    .fullWidth & {
      flex-grow: 1;
    }
  }
`;
type Props<T extends string | boolean> = {
  value?: T;
  onChange: (value: T) => void;
  options: {
    label: ReactNode;
    value: T;
  }[];
  onlyGrowOnSelected?: boolean;
  className?: string;
} & Pick<ComponentProps<typeof TabBar>, 'variant' | 'compact' | 'transparent'>;

export const TextSwitch = <T extends string | boolean>({
  value,
  onChange,
  options,
  compact,
  transparent,
  variant,
  onlyGrowOnSelected,
  className,
}: Props<T>) => {
  return (
    <StyledTabBar
      compact={compact}
      fullWidth
      forceMobileLayout
      value={value?.toString()}
      transparent={transparent}
      variant={variant}
      className={className}
      hideBackgroundWhenNoValue
    >
      {options.map(({ label, value: v }) => (
        <StyledTab
          key={v.toString()}
          value={v.toString()}
          onClick={() => onChange(v)}
          className={classNames({
            onlyGrowOnSelected,
            growOnSelected: onlyGrowOnSelected && value === v,
          })}
        >
          {label}
        </StyledTab>
      ))}
    </StyledTabBar>
  );
};
